import * as React from 'react'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {getFilterKey, getSortByLabels} from 'components/SortBy/helpers'
import useShowOverlay from 'hooks/useShowOverlay/useShowOverlay'
import {OverlayType} from 'modules/overlay/types'
import {getSortParams} from 'modules/search/selectors'

import {Pill} from '@vio/atlas/Pill'
import {useBrand} from '@vio/core/src/_web/brand/hooks/useBrand'
import {trackEvent} from '@vio/core/src/analytics/modules/actions'
import {Action, Category, Entity} from '@vio/core/src/analytics/types/Events'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'

interface Props {
  isActive?: boolean
}

export const SortByDisplayContainer = ({isActive = false}: Props) => {
  const dispatch = useDispatch()
  const {sortField, sortOrder} = useSelector(getSortParams)
  const {formatMessage} = useIntl()
  const {brand} = useBrand()
  const sortLabels = getSortByLabels()
  const showOverlay = useShowOverlay()

  const handleShowSortBy = () => {
    showOverlay({type: OverlayType.SortBy})
    dispatch(
      trackEvent({
        category: Category.User,
        entity: Entity.SortButton,
        action: Action.Clicked
      })
    )
  }

  const tier = brand.tierLabel

  const content = () => {
    if (sortField) {
      return formatMessage(
        sortLabels[getFilterKey(sortField, sortOrder)?.key],
        {
          tier
        }
      )
    } else {
      return <FormattedMessageWrapper id="sort" defaultMessage="Sort" />
    }
  }

  return (
    <>
      <Pill
        dataId="sortByFilter"
        isSelected={Boolean(isActive)}
        showArrow
        fullWidth={false}
        onClick={handleShowSortBy}
      >
        {content()}
      </Pill>
    </>
  )
}
